import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import store from "../store/store";

import de from 'vuetify/src/locale/de.ts';
import en from 'vuetify/src/locale/en.ts';

import { Ripple } from "vuetify/lib/directives";

Vue.use(Vuetify, {
    directives: {
        Ripple
    }
});

Vue.use(require('vue-cookies'))

Vue.component('my-component', {
    methods: {
        changeLocale() {
            if (store.state.auth.user) {
                this.$vuetify.lang.current = 'de';
            } else {
                this.$vuetify.lang.current = 'de';
            }
        },
    },
})

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            dark: false,
            light: {
                primary: '#1e6668',
                secondary: '#b0bec5',
                accent: '#8c9eff',
                error: '#b71c1c',
            }
        },
    },
    lang: {
        locales: { de, en },
        current: store.state.auth.user ? store.state.auth.user.language_id : 'de'
    }
});